export class HandleUserNeedingEmailConfirmationMessage {
  email: string
  
  constructor(email: string) {
    this.email = email
  }
}
    